import React from 'react';
import ComingSoonWrap from '../../meta/ComingSoon';
import { animate, motion, useMotionValue } from 'motion/react';
import { Link } from 'react-router-dom';

const FooterListItem: React.FC<any> = ({ children }) => {
    const barWidth = useMotionValue('0%');
    const textScale = useMotionValue(1);

    return (
        <motion.li
            style={{ scale: textScale }}
            onHoverStart={() => {
                animate(barWidth, '100%');
                animate(textScale, 1.05);
            }}
            onHoverEnd={() => {
                animate(barWidth, '0%');
                animate(textScale, 1);
            }}
            className='w-full hover:cursor-pointer relative'>
            <motion.span style={{ scale: textScale }}>{children}</motion.span>
            <motion.div style={{ width: barWidth }} className='h-1 mt-1 right-0 bottom-0 bg-white absolute' />
        </motion.li>
    )
}

const TryhardFooter = () => {
    return (
        <div className='grid grid-cols-2 sm:flex gap-y-2 gap-x-6 px-6 py-6 bg-red-700 text-white'>
            <div className='flex flex-col'>
                <h2 className='font-semibold italic text-teko text-3xl'>Need help?</h2>
                <ul className='text-xl gap-y-4 w-full'>
                    <ComingSoonWrap>
                        <FooterListItem>FAQ</FooterListItem>
                    </ComingSoonWrap>
                    <ComingSoonWrap>
                        <FooterListItem>Customer Service</FooterListItem>
                    </ComingSoonWrap>
                    <Link to='/tryhard/contact'>
                        <FooterListItem>Contact</FooterListItem>
                    </Link>
                </ul>
            </div>

            <div className='flex flex-col'>
                <h2 className='font-semibold italic text-teko text-3xl'>Legal</h2>
                <ul className='text-xl gap-y-4 w-full'>
                    <ComingSoonWrap>
                        <FooterListItem>Privacy Notice</FooterListItem>
                    </ComingSoonWrap>
                    <ComingSoonWrap>
                        <FooterListItem>Cancellations</FooterListItem>
                    </ComingSoonWrap>
                </ul>
            </div>

            <div className='flex flex-col'>
                <h2 className='font-semibold italic text-teko text-3xl'>Retail</h2>
                <ul className='text-xl gap-y-4 w-full'>
                    <ComingSoonWrap>
                        <FooterListItem>Our Partners</FooterListItem>
                    </ComingSoonWrap>
                    <ComingSoonWrap>
                        <FooterListItem>Store Finder</FooterListItem>
                    </ComingSoonWrap>
                </ul>
            </div>
        </div>
    )
}

export default TryhardFooter;